import { MapPin } from "lucide-react";

interface WorkflowStep {
  label: string;
  description: string;
}

const WORKFLOW_STEPS: WorkflowStep[] = [
  {
    label: "Revisa los indicadores clave del día anterior",
    description:
      "Consulta los reportes para detectar tendencias y tomar decisiones informadas.",
  },
  {
    label: "Atiende las tareas pendientes y notificaciones",
    description:
      "Prioriza lo urgente: aprobaciones, vencimientos y seguimientos de clientes.",
  },
  {
    label: "Registra las operaciones realizadas durante el día",
    description:
      "Mantén los datos al día para que los reportes reflejen la realidad del negocio.",
  },
  {
    label: "Verifica que todo esté en orden antes de cerrar",
    description:
      "Asegúrate de que no queden registros pendientes ni inconsistencias.",
  },
];

export const GettingStartedCard = () => {
  return (
    <div className="card-compact flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <span className="w-8 h-8 rounded-lg bg-global-overlay-secondary border border-global-primary flex items-center justify-center shrink-0">
          <MapPin className="w-4 h-4 text-global-accent" aria-hidden="true" />
        </span>
        <div>
          <h2 className="text-size-base font-semibold text-global-title">
            Flujo Diario Sugerido
          </h2>
          <p className="text-size-xs text-global-muted">
            Pasos recomendados para gerentes
          </p>
        </div>
      </div>

      <ol className="flex flex-col gap-3" role="list">
        {WORKFLOW_STEPS.map((step, index) => (
          <li key={step.label} className="flex items-start gap-3 min-w-0">
            <span
              className="w-6 h-6 rounded-full bg-global-overlay-secondary border border-global-primary flex items-center justify-center shrink-0 mt-0.5"
              aria-hidden="true"
            >
              <span className="text-[11px] font-bold text-global-accent">
                {index + 1}
              </span>
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-size-xs sm:text-size-sm font-medium text-global-title leading-snug">
                {step.label}
              </p>
              <p className="text-size-2xs sm:text-size-xs text-global-muted mt-0.5 leading-snug">
                {step.description}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};
